import type { IDictionariesMap } from '@sravni/types/lib/dictionaries';
import type { IVitrinaConfig } from '@sravni/vitrina/lib/types/config/IVitrinaConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import { getDictionaries, getProductConfig, getProducts } from '../selectors/productPopupInfo';

import { useAppSelector } from './redux';

export const useProducts = (): Record<string, IProduct> => useAppSelector(getProducts);

export const useProductConfig = (): IVitrinaConfig => useAppSelector(getProductConfig);

export const useDictionaries = (): IDictionariesMap => useAppSelector(getDictionaries);
